import { nip19 } from 'nostr-tools';
import { useParams } from 'react-router-dom';
import NotFound from './NotFound';
import LetterPage from './LetterPage';

export function NIP19Page() {
  const { nip19: identifier } = useParams<{ nip19: string }>();

  if (!identifier) {
    return <NotFound />;
  }

  let decoded;
  try {
    decoded = nip19.decode(identifier);
  } catch {
    return <NotFound />;
  }

  const { type, data } = decoded;

  switch (type) {
    case 'note':
      return <LetterPage eventId={data as string} />;

    case 'nevent': {
      const { id } = data as { id: string };
      return <LetterPage eventId={id} />;
    }

    case 'npub':
    case 'nprofile': {
      window.location.replace(`https://primal.net/p/${identifier}`);
      return null;
    }

    case 'naddr':
    default:
      return <NotFound />;
  }
}
